(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'BucketItemEdit',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		var $modal    = $('.modal');
		var bucket_id = null;

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		if (response.status !== 'success') {
			Adzuki.StatusMessage('Error', 'There was an error saving the bucket item');
			return false;
		}

		bucket_id = response.data.bucket_id;

		Adzuki.StatusMessage('success', 'Your bucket item has been updated', 'Success', {
			onClose: function savedClosed() {
				if (response.data.change_bucket) {
					$modal.modal('hide');
					return;
				}

				Adzuki.Ajax.get('/Buckets/items/' + bucket_id)
				.then(function _showBucketItems(response) {
					$('.bucket-contents').html(response);

					Adzuki.Ajax.get('/Buckets/addEditAttachment/' + bucket_id)
					.then(function _addEditAttachment(response) {
						$('#bucket-files').html(response);
						Adzuki.Form.initAjaxForm('BucketAttachment');
						setTimeout(
							function initDragAndDrop() {
								Adzuki.DragDropUpload.start($('.file-upload-options'));
							},
						500);
					});

					Adzuki.Ajax.get('/Buckets/addEditLink/' + bucket_id)
					.then(function _addEditLink(response) {
						$('#bucket-links').html(response);
						Adzuki.Form.initAjaxForm('BucketLink');
					});
				});
			},
		});

		return false;
	};

	form.error = function error()
	{
		Adzuki.StatusMessage('Error', 'Error saving bucket item');

		return false;
	};
}(jQuery, window.Adzuki || {}));
